import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { getImageUrl } from '../utils/api'

interface DetailSidebarThreeProps {
    agent?: {
        name: string;
        phone?: string;
        avatar?: string;
    }
}

export default function DetailSidebarThree({ agent }: DetailSidebarThreeProps) {
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState("I'm interested in working with you.");

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!email || !phone) {
            alert('Please fill out all required fields.');
            return;
        }
        setSubmitted(true);
    };

    return (
        <div className="space-y-8">
            <div className="bg-white dark:bg-slate-900 rounded-[32px] border border-slate-100 dark:border-slate-800 shadow-xl shadow-slate-200/50 dark:shadow-none overflow-hidden transition-all duration-300">
                <div className="bg-gradient-to-br from-purple-900 via-purple-800 to-violet-900 p-6 border-b border-purple-700/40">
                    <div className="flex items-center gap-4">
                        <div className="w-14 h-14 rounded-2xl overflow-hidden ring-2 ring-white/20 shrink-0">
                            <img src={agent?.avatar ? getImageUrl(agent.avatar) : '/assets/img/user-1.jpg'} alt={agent?.name} className="w-full h-full object-cover" />
                        </div>
                        <div>
                            <h4 className="text-white font-extrabold tracking-tight text-sm">
                                Inquire with {agent?.name || 'Agent'}
                            </h4>
                            <span className="text-purple-300 text-[10px] font-bold uppercase tracking-widest block mt-0.5">
                                Secure Message Portal
                            </span>
                        </div>
                    </div>
                </div>
                
                {submitted ? (
                    <div className="p-8 text-center py-12 space-y-4 animate-fadeIn">
                        <div className="w-16 h-16 bg-emerald-50 dark:bg-emerald-950/20 rounded-full flex items-center justify-center mx-auto text-emerald-500 dark:text-emerald-450 border border-emerald-100 dark:border-emerald-900/30">
                            <i className="fa-solid fa-circle-check text-2xl"></i>
                        </div>
                        <h4 className="text-base font-extrabold text-slate-900 dark:text-white uppercase tracking-wider">Message Sent!</h4>
                        <p className="text-xs text-slate-500 dark:text-slate-400 max-w-[240px] mx-auto leading-relaxed">
                            Thank you for your interest. {agent?.name || 'The agent'} will review your requirement and get in touch with you shortly.
                        </p>
                        <button 
                            onClick={() => {
                                setSubmitted(false);
                                setEmail('');
                                setPhone('');
                            }}
                            className="mt-4 px-6 py-2.5 rounded-xl border border-slate-200 dark:border-slate-800 text-xs font-extrabold hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
                        >
                            Send Another Message
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-8 space-y-5">
                        <div className="space-y-2">
                            <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-1">Your Email</label>
                            <input 
                                type="email" 
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800/80 rounded-2xl px-5 py-3.5 text-xs font-bold text-slate-905 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition-all shadow-inner" 
                                placeholder="Enter your email" 
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-1">Phone Number</label>
                            <input 
                                type="tel" 
                                required
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                className="w-full bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800/80 rounded-2xl px-5 py-3.5 text-xs font-bold text-slate-905 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition-all shadow-inner" 
                                placeholder="Your mobile number" 
                            />
                        </div>
                        <div className="space-y-2">
                            <label className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-1">Requirement</label>
                            <textarea 
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className="w-full bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800/80 rounded-2xl px-5 py-4 text-xs font-bold text-slate-905 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition-all shadow-inner min-h-[100px] resize-none"
                            ></textarea>
                        </div>
                        <button type="submit" className="w-full py-4 rounded-2xl text-white font-black uppercase tracking-widest text-[10px] hover:opacity-90 hover:scale-[1.02] active:scale-95 transition-all shadow-lg mt-2" style={{ background: 'linear-gradient(90deg, #05144b 0%, #4c1d95 100%)' }}>
                            Contact Us
                        </button>
                    </form>
                )}
            </div>
        </div>
    )
}
